// "About and legal" dialog: the engine version and the three legal
// links. Built lazily on the existing <dialog> pattern.

const DIALOG_ID = 'about-modal';

const LINKS: ReadonlyArray<readonly [string, string]> = [
  ['https://kolistat.com/terms', 'Terms of service'],
  ['https://kolistat.com/privacy', 'Privacy notice'],
  ['/third-party-licenses.txt', 'Third-party licences'],
  ['https://kolistat.com', 'kolistat.com'],
];

export function openAboutModal(engineVersion: string): void {
  let dialog = document.getElementById(DIALOG_ID) as HTMLDialogElement | null;
  if (!dialog) {
    dialog = document.createElement('dialog');
    dialog.id = DIALOG_ID;
    document.body.appendChild(dialog);
    dialog.addEventListener('click', (ev) => {
      if (ev.target === dialog) dialog!.close();
    });
  }
  dialog.innerHTML = '';

  const title = document.createElement('div');
  title.className = 'login-title';
  title.textContent = 'k0-lang editor';
  dialog.appendChild(title);

  const version = document.createElement('p');
  version.className = 'about-version';
  version.textContent = engineVersion;
  dialog.appendChild(version);

  const list = document.createElement('ul');
  list.className = 'about-links';
  for (const [href, text] of LINKS) {
    const li = document.createElement('li');
    const a = document.createElement('a');
    a.href = href;
    a.textContent = text;
    a.target = '_blank';
    a.rel = 'noopener';
    li.appendChild(a);
    list.appendChild(li);
  }
  dialog.appendChild(list);

  const close = document.createElement('button');
  close.type = 'button';
  close.className = 'btn about-close';
  close.textContent = 'Close';
  close.addEventListener('click', () => dialog!.close());
  dialog.appendChild(close);

  if (typeof dialog.showModal === 'function') dialog.showModal();
  else dialog.setAttribute('open', '');
}
